import { connect } from 'react-redux';
import EventFromView from './index'
import {loadEvents, saveEvent, updateEvent} from '../../actions/Events'
import { formValueSelector } from 'redux-form'

const mapStateToProps = (state, props) => {
    return {
	getFormValue: (name) => {
	    return formValueSelector('event')(state, name)
	}
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	saveEvent: (data) => {
	    return dispatch(saveEvent(data)).then(() =>  dispatch(loadEvents()))
	},
	updateEvent: (data) => {
	    return dispatch(updateEvent(data)).then(() =>  dispatch(loadEvents()))
	}
    }
}

const EventFromContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(EventFromView);




export default EventFromContainer;



// WEBPACK FOOTER //
// ./src/components/EventForm/Container.js